import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  MenuItem,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  Snackbar,
} from "@mui/material";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  CTSinputNo,
  HandleCloseSnackbar,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import {
  addDeliveryOrder,
  getProductList,
  editDeleteDeliveryOrder,
  getDeliveryOrderList,
  getDriverList,
  getCustomerList,
  getUOMList,
  getCylinderList,
  getScheduleEntryList,
  getVehicleList,
} from "../../../actions/actions";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const DeliveryOrderAdd = () => {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.entry_id : null;
  let navigate = useNavigate();
  const [isSet, setIsSet] = useState(false);
  const [data, setData] = useState({
    do_no: editData ? editData.do_no : "",
    do_date: editData
      ? new Date(editData.do_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    prepared_by: editData ? editData.prepared_by : "",
    customer_name: editData ? editData.customer_name : "",
    vehicle_no: editData ? editData.vehicle_no : "",
    schedule_no: editData ? editData.schedule_no : "",
    do_details: editData ? editData.do_details : "",
  });


  /////////////////////////

  const { customer } = useSelector((state) => state.customer);
  const { cylinder } = useSelector((state) => state.cylinder);
  const { schedule_entry } = useSelector((state) => state.schedule_entry);
  const { vehicle } = useSelector((state) => state.vehicle);


  useEffect(() => {
    dispatch(getCustomerList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getCylinderList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getScheduleEntryList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getVehicleList({ page: 0, size: 999, searchKey: "" }));
  }, [dispatch]);

  /////////////////////////


  // const handleChange = ({ target }) => {
  //     const value = target.value;
  //     setData({
  //         ...data,
  //         [target.name]: value,
  //     });
  //     data[target.name] = target.value;
  // }
  const handleChange = ({ target }) => {
    const value = target.value;

    setData({
      ...data,
      [target.name]: value,
    });
  };

  const onSubmit = (event) => {
    const doData = {
      ...data,
      entry_id: editid,
      do_details: JSON.stringify(do_details),
      changedUpdatedValue: "edit",
    };
    if (editData) {
      dispatch(editDeleteDeliveryOrder(doData));
    } else {
      dispatch(addDeliveryOrder(doData));
    }
  };

  const [isUpdateArray, setIsUpdateArray] = useState(false);
  const [do_details, setDo_details] = useState(
    editData
      ? JSON.parse(editData.do_details)
      : [
        {
          sr_no: "",
          cylinder_sr_no: "",
          prod_code: "",
          prod_description: "",
          cylinder_code: "",
          tag_no: "",
          sch_pdt_qty: "",
          uom: "",
        },
      ]
  );
  const handleChangeInput = (e, i) => {
    const array = [...do_details];
    let result = array[i];
    result[e.target.name] = e.target.value;
    result.srno = i + 1;
    array[i] = result;
    setDo_details(array);
    // if (e.target.name === "product") {
    //   const selectedProduct = product.find(
    //     (product) => product.prod_code === e.target.value
    //   );
    //   console.log("Selected Product:", selectedProduct); // Log the selected product
    //   if (selectedProduct) {
    //     result["product_description"] = selectedProduct.prod_description;
    //   } else {
    //     result["product_description"] = "";
    //   }
    // }
    if (e.target.name === "cylinder_sr_no") {
      const selectedCyl = cylinder.find(
        (cylinder) => cylinder.cylinder_sr_no === e.target.value
      );
      console.log("Selected Product:", selectedCyl); // Log the selected product
      if (selectedCyl) {
        result["prod_code"] = selectedCyl.prod_code;
      } else {
        result["prod_code"] = "";
      }
      if (selectedCyl) {
        result["prod_description"] = selectedCyl.prod_description;
      } else {
        result["prod_description"] = "";
      }
      if (selectedCyl) {
        result["cylinder_code"] = selectedCyl.cylinder_code;
      } else {
        result["cylinder_code"] = "";
      }
      if (selectedCyl) {
        result["uom"] = selectedCyl.uom;
      } else {
        result["uom"] = "";
      }
      if (selectedCyl) {
        result["tag_no"] = selectedCyl.tag_no;
      } else {
        result["tag_no"] = "";
      }
    }
    setIsUpdateArray(isUpdateArray ? false : true);

    array[i] = result;

    setIsSet(isSet ? false : true);
  };

  const handleRemoveDO = (index) => {
    const values = [...do_details];
    values.splice(index, 1);
    setDo_details(values);
    setIsUpdateArray(isUpdateArray ? false : true);

  };
  const handleAddSPQuotationFields = () => {
    setDo_details([
      ...do_details,
      {
        sr_no: do_details.length + 1,
        cylinder_sr_no: "",
        prod_code: "",
        prod_description: "",
        cylinder_code: "",
        tag_no: "",
        sch_pdt_qty: "",
        uom: "",
      },
    ]);
  };

  // let navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector((state) => state.delivery_order.message);
  const { shouldShowMsg, responseMessage } = useMessageHandler(
    null,
    navigate,
    setSuccessMessage,
    respMsgState
  );

  useEffect(() => { }, [shouldShowMsg, responseMessage]);

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "DO" }]} />

        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.header_txt}`}>
                  Add Delivery Order
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1} sx={{ mt: 0 }}>
              <Grid item xs={4}>
                {/* <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={12} className={`${styles.grid_input}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Customer Name
                    </Typography>
                    
                    <TextField
                      select
                      size="small"
                      fullWidth
                      onChange={handleChange}
                      name="customer_name"
                      
                      value={data.customer_name || ""}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        style: {
                          height: 30,
                          fontSize: 12,
                          backgroundColor: "white",
                        },
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: { style: { maxHeight: 200 } },
                        },
                      }}
                    >
                      
                      {customer &&
                        customer.map((customer) => (
                          <MenuItem className={`${styles.cts_lable}`}
                            key={customer.cust_id}
                            value={customer.cust_name}
                          >
                            {customer.cust_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>  
                </Grid>*/}
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      DO No
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="text"
                      onChange={handleChange}
                      name="do_no"
                      value={data.do_no}
                    />
                  </Grid>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      DO Date
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="date"
                      onChange={handleChange}
                      name="do_date" // Updated field
                      value={data.do_date}
                    />
                  </Grid>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Prepared By
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="text"
                      onChange={handleChange}
                      name="prepared_by"
                      value={data.prepared_by}
                    />
                  </Grid>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Customer Name
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      select
                      size="small"
                      fullWidth
                      onChange={handleChange}
                      name="customer_name"
                      value={data.customer_name || ""}
                      variant="outlined"
                    >
                      {customer &&
                        customer.map((customer) => (
                          <MenuItem
                            className={`${styles.cts_lable}`}
                            key={customer.cust_id}
                            value={customer.cust_name}
                          >
                            {customer.cust_name}
                          </MenuItem>
                        ))}
                    </CTSinput>
                  </Grid>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      PO No
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      select
                      type="text"
                      onChange={handleChange}
                      name="schedule_no"
                      value={data.schedule_no}
                    >
                      {schedule_entry &&
                        schedule_entry
                          .filter((entry) => entry.customer_name === data.customer_name) // Filter based on customer name
                          .map((entry) => (
                            <MenuItem
                              className={`${styles.cts_lable}`}
                              key={entry.schedule_id}
                              value={entry.schedule_no}
                            >
                              {entry.schedule_no}
                            </MenuItem>
                          ))}
                    </CTSinput>
                  </Grid>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Vehicle No
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      select
                      size="small"
                      fullWidth
                      onChange={handleChange}
                      name="vehicle_no"
                      value={data.vehicle_no}
                      variant="outlined"
                    >
                      {vehicle &&
                        vehicle.map((vehicle) => (
                          <MenuItem className={`${styles.cts_lable}`} key={vehicle.vehicle_id} value={vehicle.vehicle_no}>
                            {vehicle.vehicle_no}
                          </MenuItem>
                        ))}
                    </CTSinput>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TableContainer
                  style={{
                    maxHeight: "250px",
                    minHeight: "248px",
                    marginTop: "5px",
                  }}
                >
                  <Table
                    sx={{ minWidth: 750 }}
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          width="8%"
                        >
                          Sr No
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          width="25%"
                        >
                          Cyl No
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          width="25%"
                        >
                          Product Code
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          width="35%"
                        >
                          Product Description
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Cylinder Code
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Cylinder Tag
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Sch Pdt Qty
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          UOM
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Action
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        ></StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                        ></StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {do_details &&
                        do_details.map((row, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell align="center">
                              {index + 1}
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="cylinder_sr_no"
                                value={row.cylinder_sr_no}
                                onChange={(e) => handleChangeInput(e, index)}
                                select
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              >
                                {cylinder
                                  .filter(cylinder => cylinder.cylinder_location === "FG store")
                                  .map(filteredCylinder => (
                                    <MenuItem className={`${styles.cts_lable}`}
                                      key={filteredCylinder.cyl_id}
                                      value={filteredCylinder.cylinder_sr_no}
                                    >
                                      {filteredCylinder.cylinder_sr_no}
                                    </MenuItem>
                                  ))}
                              </CTSinput>
                            </StyledTableCell>
                            <StyledTableCell>
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="prod_code"
                                value={row.prod_code}
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="prod_description"
                                value={row.prod_description} // This should be auto-filled based on the selected product
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="cylinder_code"
                                value={row.cylinder_code}
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="tag_no"
                                value={row.tag_no}
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="sch_pdt_qty"
                                value={row.sch_pdt_qty}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="uom"
                                value={row.uom}
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="right">
                              <Box
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={handleAddSPQuotationFields}
                                >
                                  <AddIcon
                                    sx={{
                                      fontSize: "16px",
                                      color: "#1b52d1",
                                      border: "1px solid #1b52d1",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </IconButton>
                                {index === 0 ? (
                                  <IconButton
                                    disabled
                                    size="small"
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{
                                        color: "#c0c0c0",
                                        fontSize: "18px",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRemoveDO(index)}
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{ fontSize: "18px" }}
                                    />
                                  </IconButton>
                                )}
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box sx={{ marginTop: "12px", float: "right" }}>
                  <Button
                    color="primary"
                    id={`${styles.btn_save}`}
                    variant="contained"
                    type="submit"
                  >
                    <SaveIcon
                      style={{ fontSize: "16px", marginRight: "10px" }}
                    />{" "}
                    {editData ? "Update" : "Save"}
                  </Button>
                  <Cancel />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default DeliveryOrderAdd;
